module.exports = __webpack_public_path__ + "88ebb0e6e88abea335d69aab667dc44a.svg";